export const COUNTRYLIST_SEARCH = 'COUNTRYLIST_SEARCH'
export const COUNTRYLIST_PAGE = 'COUNTRYLIST_PAGE'
